import { render, staticRenderFns } from "./MedicionIncidenciaPagination.vue?vue&type=template&id=68d88786&"
import script from "./MedicionIncidenciaPagination.vue?vue&type=script&lang=js&"
export * from "./MedicionIncidenciaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports